import { useAccountState } from '../../redux/reducers/accountReducer';
import { useLocation } from "react-router";
import { useCaseService } from "../../data/services";
import { MessageContext } from "../../data/types/aiTypes";

export const useCopilotContext = () => {

    //Hooks
    const { primaryAccount } = useAccountState();
    const caseService = useCaseService();
    const { pathname, state } = useLocation();

    //Context
    const getContext = async (): Promise<MessageContext> => {

        const caseId = pathname.startsWith('/case/')
            ? pathname.split('/')[2]
            : undefined;

        const caseName = (await caseService.getCaseAsync(caseId || ''))?.caseName || undefined;

        //get the local timezone of the user for better response from copilot
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        const context: MessageContext = {
            accountId: primaryAccount?.account.accountId,
            userId: primaryAccount?.user.userId,
            caseId: caseId,
            timezone: timezone,
            caseName: caseName,
            pathname: pathname,
        };

        return context;
    };

    return { getContext };
}